export const articleMap = {
    tag: {
        buyer: 136,
        mortgage: 111,
        mortgageApplication: 179,
        mortgageCalculator: 182,
        preApproval: 178,
        preQualified: 198,
        mortgageRates: 86,
        sell: 66,
    },
    category: {
        basics: 167,
        realestate: 48,
        buyingselling: 264,
    },
};